import React from "react"
import { Button, ToolTip } from "@drifthq/tide-core"
import cx from 'classnames'
import './style.css'

export const DisabledButton = ({ buttonText, toolTipText, buttonClassName, size="large" }) => (
  <ToolTip flow="up" className="onboarding-disabled-button-wrapper" component={toolTipText}>
    <Button className={cx("onboarding-disabled-button", buttonClassName)} size={size} submit disabled={true}>
      {!!buttonText ? buttonText: "Next"}
    </Button>
  </ToolTip>
)


// WEBPACK FOOTER //
// ./src/components/OnboardingDisabledButton/index.js